import * as CONSTANTS from './constants'

const initialState = {
  loading: false,
  loadingLabel: undefined,
}

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.START_LOADING:
      return {
        ...state,
        loading: true,
        loadingLabel: action.payload?.label,
      }
    case CONSTANTS.END_LOADING:
      return {
        ...state,
        loading: false,
        loadingLabel: undefined,
      }
    default:
      return state
  }
}
